
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.75 2.833H8.5a2.833 2.833 0 00-2.833 2.833v4.25H2.834v2.834h2.833v2.833H2.834v2.833h2.833v2.834H2.834v2.833h2.833v4.25A2.833 2.833 0 008.5 31.166h21.25a1.417 1.417 0 001.417-1.416V4.25a1.417 1.417 0 00-1.417-1.417zM18.417 7.082a4.265 4.265 0 014.25 4.25 4.267 4.267 0 01-4.25 4.251c-2.333 0-4.25-1.917-4.25-4.251a4.266 4.266 0 014.25-4.25zm8.5 18.418h-17v-1.063c0-3.143 3.832-6.375 8.5-6.375s8.5 3.232 8.5 6.375V25.5z","fill":"#FFB300"}})])
          )
        }
      }
    